var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMenu)?_c('div',{staticClass:"nav-menu"},[_c('div',{staticClass:"nav-menu-body"},_vm._l((_vm.navList),function(item){return _c('div',{key:item.category,class:{
            'menu-item':true,
            'sel-color':_vm.selectMenu == item.key_name,
            'nsel-color':_vm.selectMenu!=item.key_name,
            'pointer':true
        },on:{"click":function($event){return _vm.clickMenu(item.key_name)}}},[_c('div',[_vm._v(_vm._s(item.key_name))])])}),0),_c('div',{staticClass:"mask",on:{"click":_vm.closeMask}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }